import { Link } from 'gatsby';
import React, { useContext } from 'react';
import { ResponsiveContext } from '../../../contexts/ResponsiveContext';
import { useCurrentPath } from '../../../contexts/useCurrentPath';
import { MainPath } from '../../../types/types';
import { useLocation } from '../../../contexts/useLocation';
import { isHomeScreen } from '../../../utils/screenRouteChecks';

interface Props {
  path: MainPath;
  label: string;
  route: string;
};

const NavbarButton = ({ path, label, route }: Props) => {
  const { responsiveState, dispatch } = useContext(ResponsiveContext);
  const currentPath = useCurrentPath();
  const { pathname } = useLocation();

  const closeMenu = () => {
    if (responsiveState.isMenuActive) {
      dispatch({ type: 'toggleMenu' });
    }
  };

  return (
    <div key={path} className="flex flex-col shrink px-1 w-full items-center">
      <Link to={route} className="">
        <button
          type="button"
         className={`text-xs md:text-sm lg:text-base font-medium rounded px-1 mx-auto whitespace-break-spaces lg:whitespace-nowrap hover:text-vivid-orange dark:hover:text-vivid-orange
          ${
            isHomeScreen(pathname)
              ? 'text-soft-blue-grey'
              : currentPath === path
              ? 'text-vivid-orange'
              : 'text-very-dark-grey dark:text-soft-blue-grey'
          }
        `}
          onClick={closeMenu}
        >
          {label}
        </button>
      </Link>
    </div>
  );
};

export default NavbarButton;
